import { render, staticRenderFns } from "./pushPage.vue?vue&type=template&id=aa2b74de&scoped=true&"
import script from "./pushPage.vue?vue&type=script&lang=js&"
export * from "./pushPage.vue?vue&type=script&lang=js&"
import style0 from "./pushPage.vue?vue&type=style&index=0&id=aa2b74de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2b74de",
  null
  
)

export default component.exports